import { client as axios } from "./axiosClient";
import { Constants } from "@socialcoach/services";
import { catchServiceException } from "@socialcoach/services";
import { CoachAppSetting, PlayerAppSetting } from "../interfaces";

const SETTINGS_SERVICE = `${Constants.API_URL}/settings`;

export class SettingsServices {
  @catchServiceException()
  static async getAppSettingsByCoachId(coachId: string | number): Promise<CoachAppSetting> {
    const { data } = await axios.get<CoachAppSetting>(`${SETTINGS_SERVICE}/${coachId}`, {
      withCredentials: true,
    });
    return data;
  }

  @catchServiceException()
  static async getAppSettingsByPlayerId(playerId: number | string): Promise<PlayerAppSetting> {
    const { data } = await axios.get<PlayerAppSetting>(`${SETTINGS_SERVICE}/player/${playerId}`, {
      withCredentials: true,
    });
    return data;
  }
}
